import { render, staticRenderFns } from "./BtnInserirManutencao.vue?vue&type=template&id=068d39fd&"
import script from "./BtnInserirManutencao.vue?vue&type=script&lang=js&"
export * from "./BtnInserirManutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports